<template>
<div>
    <BasePage v-bind="config" :list="filterList" v-on="listeners"></BasePage>
</div>
    
</template>

<script>
import BasePage from './BasePage.vue'
import {sspApi} from '@/api';
import _ from 'lodash'

export default {
    components: {
        BasePage
    },
    data: function () {
        return {
            queryCondition:{
                'keyword': ""
            },
            list: [],
            listeners: {
                input: this.onInput,
                // operation: this.doOperation,
                // action: this.doAction,
            },
            config:{
                searchConfigs: [
                    [
                    {name:'keyword', label:'媒体名或ID: ',ctx:'inputText'},
                    ]
                ],
                tableConfigs: [
                    {prop:'id', label:'媒体ID'},
                    {prop:'name', label:'媒体名称'},
                    {prop:'accessType', label:'接入方式'},
                    {prop:'platform', label:'平台'},
                    {prop:'createTime', label:'创建时间'},
                    {prop:'status', label:'状态'},
                ],
                actions: [],
                showAction: false
            },
        }
    },
    created: function() {
        sspApi.listMedia().then((response) => {
            this.list = response
        }).catch(this.$rejectAjaxError());
    },
    computed: {
        filterList: function () {
            let keyword = this.queryCondition.keyword
            return _.filter(this.list, (it) => {
                return (it.id + "").includes(keyword) || (it.name + "").includes(keyword)
            })
        }
    },
    methods: {
        onInput: function (val) {
            _.assign(this.queryCondition, val);
        },
    }
}
</script>